jQuery(document).ready(function($) {

  if(window.innerWidth > 768){
    jQuery('.product-block.product-block--header h1.h2.product-single__title').eq(0).after(jQuery('.product-block--price'))
  }
  else{
    jQuery('.product-mobile-top.mobile-only h1.h2.product-single__title').eq(0).after(jQuery('.product-block--price'))
  }
  
window.onresize = function(){
    if(window.innerWidth > 768){
    jQuery('.product-block.product-block--header h1.h2.product-single__title').eq(0).after(jQuery('.product-block--price'))
  }
  else{
    jQuery('.product-mobile-top.mobile-only h1.h2.product-single__title').eq(0).after(jQuery('.product-block--price'))
  }
}

  if (jQuery('.card-tag-buttons').data('rating-inserted')) return;

  console.log("test");
  jQuery(".card-tag-buttons").after(jQuery("[data-product-blocks]>.rating-badge"));
  jQuery('.card-tag-buttons').data('rating-inserted', true);

  jQuery('.footer__social').after(jQuery('.site-footer__bottom>form#localization_form'));

  var wholeSale = `<div class="wholesale-button_cont">
    <a class="wholesale-btn footer-btn-new" href="https://www.titanshieldgaming.com/pages/wholesale?_pos=1&_sid=27fbf105a&_ss=r">Wholesale</a>
</div>`;

var support = `<div class="support-button_cont">
    <a class="support-btn footer-btn-new" href="https://www.titanshieldgaming.com/pages/contact">Support</a>
</div>`;

  jQuery('.footer__social').after(wholeSale);
  jQuery('.wholesale-button_cont').after(support);
});

jQuery(document).ready(function(){

document.querySelectorAll('.mobile-nav__has-sublist').forEach(function(button) {
  button.addEventListener('click', function() {
    const parent = this.closest('.mobile-nav__has-sublist');
    if (parent) {
      parent.classList.toggle('opened');
    }
  });
});

});



var rrr = 0; var timerrrr = setInterval(function(){
  if(jQuery(".upsell-btn-container").length == 0 && jQuery('[data-essential-upsell-element="add-to-cart-button"]').length) {
jQuery('[data-essential-upsell-element="add-to-cart-button"]').eq(0).before(jQuery('<div class="upsell-btn-container"><div class="upsell-price-title">Save in bundles, protect value</div><span class="total-price-upsell">Total Price: <span id="total-price"></span><span></div>'))
jQuery('.upsell-btn-container').eq(0).append(jQuery('[data-essential-upsell-element="add-to-cart-button"]'))
jQuery('.upsell-btn-container').eq(0).append(jQuery('.payment-row').eq(0).clone())    ;

setInterval(function(){ 
  if( jQuery('.upsell-btn-container [data-essential-upsell-element="add-to-cart-button"]').length == 0){
    jQuery('.upsell-btn-container').eq(0).append(jQuery('[data-essential-upsell-element="add-to-cart-button"]'))
  }
  
jQuery('span#total-price').html('<div class="upsell-price-cont"><span class="regular-price">' + jQuery('[data-essential-upsell-element="add-to-cart-button"] [data-essential-upsell-element="regular-price"]').html() + '</span>' + jQuery('[data-essential-upsell-element="add-to-cart-button"] [data-essential-upsell-element="discounted-price"]').html() + '</div>')
}, 50);

jQuery('[data-essential-upsell-element="add-to-cart-button"]').append(jQuery(`<div class="upsell-button-text">
</div>`))
	
clearInterval(timerrrr);}if( rrr > 200){clearInterval(timerrrr);}rrr++;}, 1000);


// Wait until the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  var sss = 0;
  var timersss = setInterval(function () {
    var relatedEls = document.querySelectorAll('[flickity-slider]');
    if (relatedEls.length > 0) {
      relatedEls.forEach(function (relatedEl) {
        console.log(relatedEl);
        new Flickity(relatedEl, {
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          draggable: true,
          autoPlay: 8000, // Auto-advance every 8 seconds
          pauseAutoPlayOnHover: true,
          dragThreshold: 7,
          fade: false,
          friction: 0.8,
          initialIndex: 0,
          selectedAttraction: 0.14,
          adaptiveHeight: true
        });
      });
      clearInterval(timersss);
    }
    if (sss > 200) {
      clearInterval(timersss);
    }
    sss++;
  }, 50);
});
document.addEventListener('DOMContentLoaded', function () {
  // Select all quick-add buttons
  const quickAddButtons = document.querySelectorAll('.quick-add-btn');

  quickAddButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      // Add loading class
      button.classList.add('btn--loading');

      const variantId = button.getAttribute('data-variant-id');
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          // Close predictive search if needed
          const closeSearchBtn = document.querySelector('.site-header__search predictive-search.is-active .btn--close-search');
          if (closeSearchBtn) closeSearchBtn.click();

          // Check if cart drawer is already open
          const cartDrawerOpen = document.querySelector('div#CartDrawer.drawer--right.drawer--is-open');

          if (!cartDrawerOpen) {
            const cartViewLink = document.querySelector('a#cart_items_view_cust');
            if (cartViewLink) cartViewLink.click();
          }

          // Dispatch custom cart event
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          // Remove loading class
          button.classList.remove('btn--loading');
        });
      } else {
        // Remove loading class if no variant id
        button.classList.remove('btn--loading');
      }
    });
  });
});





var ur = window.location.href;
if(ur.includes('/product')){
 
   var rr = 0; var timerrr = setInterval(function(){
  if($('.appio-rating-badge.appio-rating-major').length) {
$('.product-section .appio-rating-raters').html($('.product-section .appio-rating-raters').html().replace('.', ','))
   $('h1.h2.product-single__title').before($('.appio-rating-badge.appio-rating-major'))	
clearInterval(timerrr);}if( rr > 200){clearInterval(timerrr);}rr++;}, 50);

}

var ur = window.location.href;
if(ur.includes('/product')){
const removeWidthParam = () => {
  const images = document.querySelectorAll('[data-essential-upsell-element="image"]');
  if (images.length === 0) return;

  images.forEach(el => {
    if (el.src) {
      const newUrl = el.src.replace(/([&?])width=\d+(&?)/, (match, p1, p2) => {
        if (p1 === '?' && !p2) return '';
        if (p1 === '&' && !p2) return '';
        return p1 === '?' ? '?' : (p2 ? '&' : '');
      }).replace(/[?&]$/, '');
      el.src = newUrl;
    }
  });

  // Stop polling once done
  clearInterval(intervalId);
};

const intervalId = setInterval(removeWidthParam, 300);
  
}


var ur = window.location.href;
if(ur.includes('/product')){
 setInterval(function(){ 


  if( document.querySelectorAll('.invo-inventory-count').length) {
	

let invCount = "";
const locs = document.querySelectorAll('.invo-location-name');
const locationCode = document.querySelector('span#location-code')?.textContent.trim();
var noAssignedCountries = true;
for (let i = 0; i < locs.length; i++) {
  const firstWord = locs[i].textContent.trim().split(' ')[0];
  if (firstWord === locationCode) {
    noAssignedCountries = false;
    const invEl = document.querySelectorAll('.invo-status-container')[i];
    if (invEl) {
      invCount = invEl.innerHTML;
    }
  }
}
if (noAssignedCountries == true){
for (let i = 0; i < locs.length; i++) {
  const firstWord = locs[i].textContent.trim().split(' ')[0];
  if (firstWord == "DE") {
    noAssignedCountries = true;
    const invEl = document.querySelectorAll('.invo-status-container')[i];
    if (invEl) {
      invCount = invEl.innerHTML;
    }
  }
}
}

document.querySelectorAll('.stock-level')[0].innerHTML = invCount;
document.querySelectorAll('.stock-level')[1].innerHTML = invCount;

if(document.querySelectorAll('.stock-level .invo-status-out_of_stock').length){
document.querySelectorAll('.product-block button.btn.btn--full.add-to-cart')[0].classList.add('sold-out');
}
else{
document.querySelectorAll('.product-block button.btn.btn--full.add-to-cart')[0].classList.remove('sold-out');
}
  }
}, 1000);
}


var ur = window.location.href;
if(!ur.includes('/product')){
 setInterval(function(){ 


  if( document.querySelectorAll('.grid__item.grid-product .invo-inventory-count').length) {
	

document.querySelectorAll('.grid__item.grid-product').forEach(function(product) {

  const locationCode = product.querySelector('span#location-code')?.textContent.trim();

  const containers = product.querySelectorAll('.invo-container');

  let bestPriority = 4; // 1=in stock, 2=low, 3=out
  let bestHTML = "";

  containers.forEach(container => {

    const locations = container.querySelectorAll('.invo-location');

    let matchedIndex = -1;

    // 1. try exact location match
    locations.forEach((loc, i) => {
      const name = loc.querySelector('.invo-location-name')?.textContent.trim().split(' ')[0];
      if (name === locationCode) matchedIndex = i;
    });

    // 2. fallback to DE if none matched
    if (matchedIndex === -1) {
      locations.forEach((loc, i) => {
        const name = loc.querySelector('.invo-location-name')?.textContent.trim().split(' ')[0];
        if (name === "DE") matchedIndex = i;
      });
    }

    if (matchedIndex === -1) return;

    const statusEl = locations[matchedIndex].querySelector('.invo-status-container');
    if (!statusEl) return;

    const statusText = statusEl.textContent.toLowerCase();

    let priority = 3;

    if (statusText.includes("in stock")) priority = 1;
    else if (statusText.includes("low stock")) priority = 2;
    else priority = 3;

    if (priority < bestPriority) {
      bestPriority = priority;
      bestHTML = statusEl.innerHTML;
    }

  });

  const stockLevel = product.querySelector('.stock-level.collection');

  if (stockLevel && bestHTML) {
    stockLevel.innerHTML = bestHTML;
  }

});


  }
}, 1000);
}



 setTimeout(function(){ 


var ur = window.location.href;
if(ur.includes('/product') && document.querySelectorAll('.logged-in').length){
 setInterval(() => {

  // get original price
  var origPrice = document.querySelectorAll('.product__price')[0]?.textContent.trim().split(' ')[0];
  if (!origPrice) return;

  // locate shadow root
  const sparkPdp = document.querySelector('spark-pdp');
  if (!sparkPdp || !sparkPdp.shadowRoot) return;

  // locate price-summary inside shadow root
  const priceSummary = sparkPdp.shadowRoot.querySelector('.price-summary');
  if (!priceSummary) return;

  // avoid duplicate append
  if (!priceSummary.querySelector('.orig-price')) {
    const span = document.createElement('span');
    span.className = 'orig-price text-[length:var(--sl-pricing-fontsize-small)] font-[--sl-pricing-font-weight] md:text-[length:var(--sl-pricing-fontsize)]';
    span.textContent = "MSRP: " + origPrice;
    span.setAttribute("style", "margin-left:-10px; text-decoration:line-through;");
    priceSummary.appendChild(span);
  }
}, 100);
 
}
}, 1000);


 setInterval(function(){ 


  const wrappers = document.querySelectorAll(".featured-collection-wrapper");

  wrappers.forEach(wrapper => {
    const contents = wrapper.querySelectorAll(".grid-product__content");
    let maxHeight = 0;

    contents.forEach(content => {
      const h = content.offsetHeight;
      if (h > maxHeight) {
        maxHeight = h;
      }
    });

    if (maxHeight > 0) {
      const viewport = wrapper.querySelector(".flickity-viewport");
      if (viewport) {
        viewport.style.minHeight = (maxHeight + 40) + "px";
      }
    }
  });

  
}, 1000);


// Collection Description Learn More Toggle
document.addEventListener('DOMContentLoaded', function() {
  initLearnMoreToggle();
});

// Also try to init after a delay in case DOM loads differently
setTimeout(function() {
  initLearnMoreToggle();
}, 500);

function initLearnMoreToggle() {
  const learnMoreBtn = document.querySelector('[data-learn-more]');
  
  if (learnMoreBtn && !learnMoreBtn.hasAttribute('data-initialized')) {
    learnMoreBtn.setAttribute('data-initialized', 'true');
    
    const descriptionText = document.querySelector('[data-description-text]');
    const learnMoreText = learnMoreBtn.querySelector('.learn-more-text');
    const learnLessText = learnMoreBtn.querySelector('.learn-less-text');
    
    // Check if there's a short intro or if we're using clamping
    const hasShortIntro = descriptionText ? descriptionText.getAttribute('data-has-short-intro') === 'true' : false;
    
    // Store the short intro text (if available)
    const shortIntro = descriptionText ? descriptionText.innerHTML : '';
    const fullDescription = descriptionText ? descriptionText.getAttribute('data-full-description') : '';
    
    learnMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (descriptionText) {
        descriptionText.classList.toggle('is-expanded');
        
        if (hasShortIntro) {
          // Toggle between short intro and full description
          if (descriptionText.classList.contains('is-expanded')) {
            descriptionText.innerHTML = fullDescription;
            if (learnMoreText) learnMoreText.style.display = 'none';
            if (learnLessText) learnLessText.style.display = 'inline';
          } else {
            descriptionText.innerHTML = shortIntro;
            if (learnMoreText) learnMoreText.style.display = 'inline';
            if (learnLessText) learnLessText.style.display = 'none';
          }
        } else {
          // Just toggle the clamp class for full description
          if (descriptionText.classList.contains('is-expanded')) {
            if (learnMoreText) learnMoreText.style.display = 'none';
            if (learnLessText) learnLessText.style.display = 'inline';
          } else {
            if (learnMoreText) learnMoreText.style.display = 'inline';
            if (learnLessText) learnLessText.style.display = 'none';
          }
        }
      }
    });
  }
}